module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'details-accordion\'></div>\n<div id=\'indicators-accordion\'></div>\n<div id=\'system-info-accordion\'></div>\n';

}
return __p
}